import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { IViewModel } from "mobx-utils";
import * as React from "react";
import { api } from "../../api";
import { IUsuario } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { toast } from "react-toastify";

interface CreateUserDialogProps {
  onClose: () => void;
}

interface CreateUserDialogState {
  conta_id: any;
  list: any[];
}

@observer
export class CreateUserDialog
  extends React.Component<CreateUserDialogProps, CreateUserDialogState>
{

  obs = observable({
    usuario: null as IUsuario & IViewModel<IUsuario>,
    focusDone: false as boolean,
    currentPassword: "" as string,
    newPassword: "" as string,
    working: false as boolean,
    conta_id: [] as any,
    nome_completo: "" as string,
    email: "" as string,
    senha: "" as string,
    list: [] as String[],

  })
  focusFirst(el: HTMLInputElement) {
    if (!this.obs.focusDone) {
      el.focus();
      this.obs.focusDone = true;
    }
  }

  handleCheckChange = (permissao: [String]) => {
    if (this.state.list.indexOf(permissao) < 0) {
      this.setState(state => {
        const list = state.list.push(permissao);
      });
    } else {
      let chave = this.state.list.indexOf(permissao);
      this.state.list.splice(chave, 1);
    }
  };

  async componentDidMount() {
    this.setState({ conta_id: AppStore.obs1.contaId });
    this.setState({ list: [] });
  }

  refresh = () => {
    window.location.reload();
  };

  handleCreateUser = async () => {
    
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (!this.obs.nome_completo) {
      toast.error('Preencha o nome do usuário', {});
      return;
    }
    if (!this.obs.email) {
      toast.error('Preencha o email do usuário', {});
      return;
    }
    if (!regex.test(this.obs.email)) {
      toast.warning("E-mail inválido!", {});
      return
    }
    if (!this.obs.senha) {
      toast.error('Preencha a senha do usuário', {});
      return;
    }

    if (this.obs.senha.match(/\d/) == null || this.obs.senha.match(/[a-z]/i) == null) {
      toast.error('A senha deve conter números e letras', {});
      return;
    }

    if (this.obs.senha.length < 8) {
      toast.error('A senha deve conter 8 caracter', {});
      return;
    }
    try {
      let params = {
        nome_completo: this.obs.nome_completo,
        email: this.obs.email,
        senha: this.obs.senha,
        niveis_acesso: this.state.list,
      }

      let resp = await api.post(`/api/add-usuario-conta`, params)

      if (resp.data.ok) {
        this.props.onClose();
        toast.success('Usuário criado com sucesso', {});
        setInterval(this.refresh, 1000);
      } else {
        toast.error(resp.data.msg, {});
      }
    } catch (ex) {
      toast.error(`Erro ao criar um Usuário, tente novamente mais tarde.`, {});
    }
  }

  render() {
    return (
      <Dialog isOpen title="Adicionar Usuário" onClose={this.props.onClose}>
        <div className={Classes.DIALOG_BODY}>
          <FormGroup
            label="Nome Completo"
            labelFor="current-password"
            labelInfo="(obrigatório)"
          >
            <InputGroup
              style={{ width: "100%" }}
              onChange={(e: any) =>
                this.obs.nome_completo = e.target.value}
            />
          </FormGroup>

            <FormGroup
              label="E-mail para Acesso"
              labelFor="current-password"
              labelInfo="(obrigatório)"
            >
              <InputGroup
                name='new-email'
                autoComplete='new-email'
                style={{ width: "100%" }}
                onChange={(e: any) => this.obs.email = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="Senha"
              labelFor="current-password"
              labelInfo="(obrigatório)"
            >
              <InputGroup
                style={{ width: "100%" }}
                type="password"
                name='new-password'
                autoComplete='new-password'
                onChange={(e: any) => this.obs.senha = e.target.value}
              />
            </FormGroup>

          <h2 className="title title-permissoes">
            Selecione as permissões para esse usuário:
          </h2>
          <MDBRow>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Empresas"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="e1"
                  onChange={this.handleCheckChange.bind(this, "e1")}
                />{" "}
                Criar <br />
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="e2"
                  onChange={this.handleCheckChange.bind(this, "e2")}
                />{" "}
                Alterar <br />
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="e3"
                  onChange={this.handleCheckChange.bind(this, "e3")}
                />{" "}
                Deletar <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Cálculos"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="c1"
                  onChange={this.handleCheckChange.bind(this, "c1")}
                />{" "}
                Visualizar <br />
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="c2"
                  onChange={this.handleCheckChange.bind(this, "c2")}
                />{" "}
                Contestar <br />
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="c3"
                  onChange={this.handleCheckChange.bind(this, "c3")}
                />{" "}
                Exportar <br />
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="c4"
                  onChange={this.handleCheckChange.bind(this, "c4")}
                />{" "}
                Memória de Cálculos <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Manifestações"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="h1"
                  onChange={this.handleCheckChange.bind(this, "h1")}
                />{" "}
                Visualizar <br />
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="h2"
                  onChange={this.handleCheckChange.bind(this, "h2")}
                />{" "}
                Manifestar <br />
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="h3"
                  onChange={this.handleCheckChange.bind(this, "h3")}
                />{" "}
                Envios e Download <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Importar XMLs"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="i1"
                  onChange={this.handleCheckChange.bind(this, "i1")}
                />{" "}
                Importar <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Logs"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  defaultChecked={false}
                  className="chaves"
                  value="l1"
                  onChange={this.handleCheckChange.bind(this, "l1")}
                />{" "}
                Visualizar <br />
              </FormGroup>
            </MDBCol>
          </MDBRow>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancelar"
              onClick={this.props.onClose}
              disabled={this.obs.working}
            />
            <Button
              text="Salvar"
              intent="primary"
              onClick={this.handleCreateUser}
              loading={this.obs.working}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}
